import { useQuery } from "@tanstack/react-query";

import { getSchedulingMethods } from "../api/schedulingMethods";

export const useGetSchedulingMethods = (
  organizationId: string,
  enabled: boolean,
) => {
  return useQuery({
    queryFn: () => getSchedulingMethods({ organizationId }),
    queryKey: ["scheduling-methods", organizationId],
    enabled,
  });
};
